<template>
  <b-modal 
    id="modal-select-template-confirm" 
    header-class="align-items-center px-20 py-15 warning"
    body-class="p-20"
    footer-class="px-20 py-15"
  >
    <template #modal-header>
      <div class="modal-title">
        <span class="fs-db-28">
          {{ $t('engine.manageAppearance.theme.template.lblModalConfirmChangeTemplate',languageEngine) }}
        </span>
      </div>
      <div
        id="close-modal-confirm-delete"
        type="button"
        class="close-modal"
        aria-label="Close"
        @click="close()"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>
    <template>
      <div class="fs-sa-16">
        {{ $t('engine.manageAppearance.theme.template.lblModalConfirmDescription',languageEngine) }}
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="blue" @click.prevent="confirm()">
        <i class="far fa-check"></i>
        {{ $t('engine.manageAppearance.theme.template.lblModalConfirmChangeTemplateBtn',languageEngine) }}
      </b-button>
      <b-button variant="default" @click="close()">
        <i class="far fa-times"></i> 
        {{ $t('engine.manageAppearance.theme.template.lblModalConfirmCancelBtn',languageEngine) }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  methods: {
    close() {
      this.$bvModal.hide("modal-select-template-confirm");
      this.$emit("clear");
    },
    confirm() {
      this.$bvModal.hide("modal-select-template-confirm");
      this.$emit("confirmed");
    },
  },
};
</script>